module.exports = __webpack_public_path__ + "img/drugs.c53fb665.svg";